<template>
	<base-content navIndex="4">
		<div class="bg-lin-ef news-lin">
			<div class="width-1280 news-bg">
				<el-image class="news-bgs" :src="require('@/assets/images/news/BG@2x.png')"></el-image>
				<div class="news-title col-fff bold">咚咚匠最新政策资讯实时报道</div>
			</div>
			<div class="width-1280 pb-36">
				<div class="news-tabs bg-fff">
					<el-row>
						<el-col :span="6" v-for="(item,index) in tabsList" :key="index">
							<div class="news-tabs-item flex align-c justify-c">
								<el-image class="news-icon" :src="tabsIndex == index ? item.activeIcon : item.icon"></el-image>
								<div class="bold news-tabs-title" :class="tabsIndex == index ? 'news-tabs-active' : 'col-333'">{{item.name}}</div>
							</div>
						</el-col>
					</el-row>
				</div>
				<div class="news-list bg-fff flex align-s" v-for="(item,index) in newsList" :key="index">
					<el-image class="news-list-img" :src="require('@/assets/images/index/course1.png')"></el-image>
					<div class="news-right">
						<div class="right-title col-333 bold">
							咚咚匠公益
						</div>
						<div class="right-text">
							咚咚匠公益 咚咚匠公益专注于生态环保领域的公益项目，相信保护环境的最好时机就是现在。咚嗵匠公益希望能够发现一些容易被忽视的生态环保小问题，利用自身的资源整合力和执行力，透彻地解决真实的问题。 咚嗵匠公益的使命
						</div>
						<div class="right-footer flex align-c justify-sb">
							<div class="flex align-c">
								<el-image class="news-topic" :src="require('@/assets/images/news/#@2x.png')"></el-image>
								<div class="news-type">公司动态</div>
							</div>
							<div class="col-666 news-time">
								2023-08-10
							</div>
						</div>
					</div>
				</div>
				<div class="news-more flex align-c justify-c">浏览更多</div>
			</div>
		</div>
	</base-content>
</template>

<script>
	import baseContent from '@/components/base-content.vue'
	export default{
		components:{ baseContent },
		data(){
			return{
				activeName:'second',
				tabsIndex:0,
				tabsList:[
					{
						name:'全部资讯',
						icon:require('@/assets/images/news/all.png'),
						activeIcon:require('@/assets/images/news/all-active.png')
					},
					{
						name:'求职必读',
						icon:require('@/assets/images/news/career.png'),
						activeIcon:require('@/assets/images/news/career-active.png')
					},
					{
						name:'干货文章',
						icon:require('@/assets/images/news/article.png'),
						activeIcon:require('@/assets/images/news/article-active.png')
					},
					{
						name:'公司动态',
						icon:require('@/assets/images/news/trends.png'),
						activeIcon:require('@/assets/images/news/trends-active.png')
					}
				],
				newsList:[{},{},{},{}],
			}
		},
		mounted() {
			
		},
		methods:{
			
		}
	}
</script>

<style>
	.news-bg{
		height: 176px;
		position: relative;
	}
	.news-bgs{
		width: 1280px;
		height: 176px;
	}
	.news-lin{
		height: 832px;
	}
	.news-title{
		position: absolute;
		left: 0;
		right: 0;
		margin: auto;
		top: 44px;
		font-size: 32px;
		line-height: 45px;
		text-align: center;
	}
	.news-tabs{
		height: 70px;
		border-radius: 12px;
		width: 1040px;
		margin: auto;
		margin-top: -35px;
		position: relative;
	}
	.news-tabs-item{
		height: 70px;
		cursor: pointer;
	}
	.news-tabs-item:hover .news-tabs-title{
		color: #169BD5;
	}
	.news-icon{
		width: 36px;
		height: 36px;
		margin-right: 12px;
	}
	.news-tabs-title{
		font-size: 18px;
		line-height: 25px;
	}
	.news-tabs-active{
		color: #169BD5;
	}
	.news-more{
		margin: auto;
		margin-top: 36px;
		width: 200px;
		height: 46px;
		background: rgba(22, 155, 213, .1);
		border-radius: 8px;
		font-size: 13px;
		color: #169BD5;
	}
	.news-list{
		padding: 18px;
		border-radius: 12px;
		margin-top: 16px;
		height: 186px;
	}
	.pb-36{
		padding-bottom: 36px;
	}
	.news-list-img{
		width: 250px;
		height: 150px;
		border-radius: 10px;
	}
	.news-right{
		width: calc(100% - 250px);
		padding-left: 18px;
		height: 150px;
		position: relative;
	}
	.right-title{
		font-size: 18px;
		line-height: 25px;
	}
	.right-text{
		margin-top: 18px;
		font-size: 14px;
		line-height: 26px;
		color: #696969;
	}
	.right-footer{
		position: absolute;
		left: 0;
		right: 0;
		margin: auto;
		bottom: 0;
		padding-left: 18px;
	}
	.news-topic{
		width: 18px;
		height: 18px;
		margin-right: 8px;
	}
	.news-type{
		font-size: 14px;
		color: #9E9E9E;
		line-height: 20px;
	}
	.news-time{
		font-size: 14px;
		line-height: 20px;
	}
</style>